module.exports = __webpack_public_path__ + "82ea8999e9bcbc910056f4bed1d4b2ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navbar3.png
// module id = 224
// module chunks = 30